
export const getReportSetupConfigStarted = (state, payload) => {
    return {
        ...state,
        fetchReportSetupConfig: {
            ...state.fetchReportSetupConfig,
            isProcessing: true,
            error: false,
            isDataFetched: false
        }
    };
};

export const getReportSetupConfigSuccess = (state, payload) => {
    return {
        ...state,
        reportSetupConfig: payload.reportSetupConfig,
        fetchReportSetupConfig: {
            data: payload.reportSetupConfig,
            isProcessing: false,
            error: false,
            isDataFetched: true
        }
    };
};

export const getReportSetupConfigFail = (state, payload) => {
    return {
        ...state,
        fetchReportSetupConfig: {
            data: null,
            isProcessing: false,
            error: true,
            isDataFetched: false
        }
    };
};
